import { axiosInstance } from "@/apis/core";
import { IS_DEMO_MODE, demoParkingRecords } from "@/dummy/demo";

export interface ParkingRecord {
  id: number;
  name: string;
  phone: string;
  community: string;
  team: string;
  car: string;
  plate: string;
}

export type ParkingInput = Omit<ParkingRecord, "id">;

const BASE = "/portal-service/api/v1/parking";

// 데모 모드 전용 로컬 스토어 (페이지 수명 동안 유지)
let demoStore: ParkingRecord[] | null = null;
let demoNextId = 1;
const getDemoStore = (): ParkingRecord[] => {
  if (demoStore === null) {
    demoStore = demoParkingRecords.map((r) => ({ ...r, id: demoNextId++ }));
  }
  return demoStore;
};

export const getParkingList = async (): Promise<ParkingRecord[]> => {
  if (IS_DEMO_MODE) return [...getDemoStore()];
  const { data } = await axiosInstance.get(BASE);
  return Array.isArray(data) ? data : [];
};

export const createParking = async (
  input: ParkingInput,
): Promise<ParkingRecord> => {
  if (IS_DEMO_MODE) {
    const store = getDemoStore();
    const record: ParkingRecord = { ...input, id: demoNextId++ };
    store.push(record);
    return { ...record };
  }
  const { data } = await axiosInstance.post(BASE, input);
  return data;
};

export const updateParking = async (
  id: number,
  input: ParkingInput,
): Promise<ParkingRecord> => {
  if (IS_DEMO_MODE) {
    const store = getDemoStore();
    const idx = store.findIndex((r) => r.id === id);
    if (idx >= 0) store[idx] = { ...input, id };
    return { ...input, id };
  }
  const { data } = await axiosInstance.put(`${BASE}/${id}`, input);
  return data;
};

export const deleteParking = async (id: number): Promise<void> => {
  if (IS_DEMO_MODE) {
    const store = getDemoStore();
    const idx = store.findIndex((r) => r.id === id);
    if (idx >= 0) store.splice(idx, 1);
    return;
  }
  await axiosInstance.delete(`${BASE}/${id}`);
};
